/**
 * Скрыть некоторые цифры номера телефона
 * @param {string} number
 * @return {string}
 */
export default function maskPhoneNumber(number) {
  return number.slice(0, 4) + '*****' + number.slice(9);
}
